import { render } from "./App.vue?vue&type=template&id=645cf333"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=645cf333&lang=scss"
import "./App.vue?vue&type=style&index=1&id=645cf333&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__